import { Injectable } from '@odinjs/odin';
import { HttpService, SessionStorageService } from '@philips-internal/oswald-ui-core/lib/services';

import { UserRoutesAPI } from '../constants';
import { Customer, NewCustomerUser, User, UserCustomer, UserLocationRequest, UserPasswordRequest, UserSettingsRequest } from '../interfaces';

import { BaseService } from './BaseService';

@Injectable({})
export class UserService extends BaseService {

  static updateLocation(user: UserLocationRequest): Promise<User> {
    return this.put(UserRoutesAPI.USER_LOCATION,
      {},
      {
        body: user,
      }).then(response => {
      return response.body as User;
    });
  }

  static updateSettings(user: UserSettingsRequest): Promise<User> {
    return this.put(UserRoutesAPI.USER_SETTINGS,
      {},
      {
        body: user,
      }).then(response => {
      return response.body as User;
    });
  }

  static updateChangePassword(user: UserPasswordRequest): Promise<User> {
    return this.put(UserRoutesAPI.USER_CHANGE_PASSWORD,
      {},
      {
        body: user,
      }).then(response => {
      return response.body as User;
    });
  }

  static hasDefaultCustomer(): Promise<UserCustomer> {
    return new Promise<UserCustomer>(resolve => {
      const data = SessionStorageService.getItem('establishment');
      if (!data) {
        resolve({
          default: true,
          customerName: '',
        });
        return;
      }
      setTimeout(() => {
        SessionStorageService.removeItem('establishment');
      }, 5000);
      resolve((data as UserCustomer));
    });
  }

  static listCustomers(page: number, limit: number, dsCliente: string): Promise<Customer[]> {
    return HttpService.get(UserRoutesAPI.USER_CUSTOMERS_LIST, { page, limit, dsCliente })
      .then(response => (response.body as Customer[]));
  }

  static isUserPhilips(id: string): Promise<boolean> {
    return HttpService.get(UserRoutesAPI.USER_IS_USER_PHILIPS, { id })
      .then(response => {
        return response.body as boolean;
      });
  }

  static create(user: NewCustomerUser): Promise<NewCustomerUser> {
    console.log(user);    
    return HttpService.post(UserRoutesAPI.USER_DEFAULT, {}, { body: user }).then(response => {
      return response.body as NewCustomerUser;
    });
  }

}
